module.exports = __webpack_public_path__ + "static/SmartShoeAppPictureOldVersionSensorsSettings-214bfbb4fcaf1ff9a17471f571760967.jpg";